import { AppContextType } from '@/contexts/app-context';

export const dict: Record<string, Record<AppContextType['language'], string>> = {
    private: {
        sv: 'Privat',
        no: 'Privat',
        da: 'Privat',
        fi: 'Henkilöasiakkaat',
    },
    corporate: {
        sv: 'Företag',
        no: 'Bedrift',
        da: 'Erhverv',
        fi: 'Yritysasiakkaat',
    },
    previous: {
        sv: 'Föregående',
        no: 'Forrige',
        da: 'Forrige',
        fi: 'Edellinen',
    },
    next: {
        sv: 'Nästa',
        no: 'Neste',
        da: 'Næste',
        fi: 'Seuraava',
    },
    showing: {
        sv: 'Visar %d till %d av %d resultat',
        no: 'Viser %d til %d av %d resultater',
        da: 'Viser %d til %d af %d resultater',
        fi: 'Näytetään %d - %d / %d tulosta',
    },
    'show-all': {
        sv: 'Visa alla',
        no: 'Vis alle',
        da: 'Vis alle',
        fi: 'Näytä kaikki',
    },
};
